import { CalendarX, type Icon, Link as LinkIcon } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import type { WorkspaceAccount } from "common/types";

import useAccountActions from "../../hooks/useAccountActions";

export default function DesktopQuickAction({
  account,
}: {
  account: WorkspaceAccount;
}) {
  const { selectAction, components } = useAccountActions(account);

  const { license, state } = account;

  let actionData: {
    label: string;
    icon: Icon;
    actionName: "reactivate" | "reconnect";
  };

  if (license?.expires_at) {
    actionData = {
      label: "Remove cancellation",
      icon: CalendarX,
      actionName: "reactivate",
    };
  }
  if (state !== "LoggedIn") {
    actionData = {
      label: "Reconnect",
      icon: LinkIcon,
      actionName: "reconnect",
    };
  }

  if (actionData) {
    const { icon: Icon, label, actionName } = actionData;
    return (
      <>
        <Button
          size="sm"
          variant="secondary-black"
          leftIcon={<Icon />}
          onClick={(e) => {
            e.stopPropagation();
            selectAction(actionName);
          }}
        >
          {label}
        </Button>
        {components}
      </>
    );
  }
}
